var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"card_title",class:[{'end': _vm.isShowClose}, {'no-border': _vm.isNoBorder}]},[_c('p',{staticClass:"text_color_primary text-16-M"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),(_vm.isShowClose)?_c('i',{staticClass:"iconfont iconshanchu close",on:{"click":_vm.close}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cca3dd1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/border-title.vue
// module id = null
// module chunks = 